<template>
    <div>
        <GmapStreetViewPanorama
            ref="streetView"
            :position="position"
            :pov="{heading: 165, pitch: 0}"
            :zoom="1"
            style="width: 100%; height: 500px"
        />
    </div>
</template>

<script>
export default
{
    //extends: Component,
    components: {

    },
    props: {
        stationdetail: {
            type: Object,
            default: () => ({}), 
        },
        location: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            latitude: -6.177531921860371,
            longitude: 106.83167662845935,
            pov: null,
            pano: null,
            position: { lat: -6.177531921860371, lng: 106.83167662845935 },
        }
    },
    watch: {
        location() {
            this.position.lat = this.location.lat;
            this.position.lng = this.location.lng;
        }
    },
    mounted() {
        
    },
    methods: {
        updatePov(pov) {
            this.pov = pov;
        },
        updatePano(pano) {
            this.pano = pano;
        },
    }
}
</script>
